import ServicedQuantityCard from './ServicedQuantityCard'
import OtherChargesCard from './OtherChargesCard'
import useServicedQuantityItems from './useServicedQuantityItems'
import useOtherCharges from './useOtherCharges'
import { CardsWrapper } from './style'

const ServicedQuantity = ({ supplierPoNumber, update, editable = false }) => {
	const items = useServicedQuantityItems(supplierPoNumber, update)
	const charges = useOtherCharges(supplierPoNumber, update)

	return (
		<CardsWrapper>
			<ServicedQuantityCard {...items} editable={editable} />
			<OtherChargesCard {...charges} editable={editable} />
		</CardsWrapper>
	)
}

export default ServicedQuantity
